import { Image } from "antd";
import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

function Login(props) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [mobilefield, setMobilefield] = useState("");
  let errorsObj = { email: "", password: "" };
  let mobilefieldErrorObj = { mobilefield: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [otpErrors, setOtpErrors] = useState(mobilefieldErrorObj);
  const [password, setPassword] = useState("");
  const [loginToggle, setLoginToggle] = useState("password");
  const [otpToggle, setOtpToggle] = useState(true);
  const [passwordToggle, setPasswordToggle] = useState(false);

  const [isLoading, setLoading] = useState(false);
  const [isMobileLoading, setMobileLoading] = useState(false);

  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };

  function onLogin(e) {
    e.preventDefault();
    setLoading(true);
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      toast.error("Email is Required", toastConfig);
      setLoading(false);
      error = true;
    }
    if (password === "") {
      toast.error("Password is Required", toastConfig);
      setLoading(false);
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }

    let data = {
      emailAddress: email?.toLowerCase(),
      password: password,
    };
    // console.log({ data });

    props.apis
      .apiEmployeeLogin(data)
      .then((res) => {
        console.log({ res });

        props.store("logged", res.logged);
        props.store("loggedIn", new Date().getTime());
        props.store("auth", res.auth);
        props.store("user", res.user);
        props.store("persona", res?.user?.role);

        let loginpath;
        if (res?.user?.role === _enum.ROUTE_PERSONAS.admin) {
          loginpath = "/app/home";
        } else if (res?.user?.role === _enum.ROUTE_PERSONAS.telecaller) {
          loginpath = "/app/leads";
        } else if (res?.user?.role === _enum.ROUTE_PERSONAS.ops) {
          loginpath = "/app/leadmanagement";
        } else {
          loginpath = "/app/myprofile";
        }
        navigate(loginpath);
        setLoading(false);
      })
      .catch(() => {
        const errorObj = { ...errorsObj };
        toast.error("login failed", toastConfig);
        setErrors(errorObj);
        setLoading(false);
      });
  }

  function onEmployeeOtpLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...mobilefieldErrorObj };
    var mobilePattern = /^\d{10}$/;

    if (mobilefield === "") {
      toast.error("Mobile Number is Required", toastConfig);
      error = true;
    } else if (!mobilePattern.test(mobilefield)) {
      toast.error("Invalid Mobile Number", toastConfig);
      error = true;
    } else {
      setMobileLoading(true);
    }
    setOtpErrors(errorObj);
    if (error) {
      return;
    }
    let data = {
      mobile_number: mobilefield,
    };
    console.log({ data, mobilefield });

    props.apis
      .apiEmployeeOtpLogin(data)
      .then((res) => {
        console.log({ onOTPSubmit: res });
        props.store("OTPresponses", res);
        props.store("mobileNumber", mobilefield);

        navigate("/open/otp");
        setMobileLoading(false);
      })
      .catch((err) => {
        console.log({ OTPlogin: err });
        const errorObj = { ...errorsObj };
        toast.error("Mobile number login failed", toastConfig);
        setOtpErrors(errorObj);
        setMobileLoading(false);
      });
  }

  const handleLoginToggle = (val) => {
    setLoginToggle(val);
  };

  const toggleSwitchPassword = () => {
    const passwordField = document.querySelector("#password");
    const togglePassword = document.querySelector("#togglePassword");

    togglePassword.addEventListener("click", function () {
      if (passwordField.type === "password") {
        passwordField.type = "text";
        togglePassword.classList.remove("fa-eye");
        togglePassword.classList.add("fa-eye-slash");
      } else {
        passwordField.type = "password";
        togglePassword.classList.remove("fa-eye-slash");
        togglePassword.classList.add("fa-eye");
      }
    });
  };

  // useEffect(() => {
  //   console.log("DESTROY_SESSION");
  //   app?.props?.store("auth", false);
  //   app?.props?.store("user", false);
  //   app?.props?.store("persona", "");
  //   localStorage.clear();
  // }, []);

  props.$setNode({
    props,
  });

  return (
    <>
      <ToastContainer />
      <div className="page-wraper">
        <div className="browse-job login-style3">
          <div className="bg-img-fix overflow-hidden">
            <div className="parent-container row gx-0">
              <div
                className="col-xl-6 col-lg-6 col-md-6 col-sm-12 login_img_bg"
                style={{ backgroundImage: "url(" + imagepaths.loginBg + ")" }}
              >
                <div className="logo_header ps-3">
                  <Link to={"/open/login"} className="logo">
                    <img src={imagepaths.logoWithTagline} alt="" />
                  </Link>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
                <div className="login-form style-2 py-4">
                  <div className="card-body">
                    <div className="nav nav-tabs border-bottom-0">
                      <div className="tab-content w-100" id="nav-tabContent">
                        <div
                          className="tab-pane fade active show"
                          id="nav-personal"
                        >
                          {props.errorMessage && (
                            <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                              {props.errorMessage}
                            </div>
                          )}
                          {props.successMessage && (
                            <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                              {props.successMessage}
                            </div>
                          )}
                          <div className="w-100 text-center">
                            <Image
                              src={imagepaths.logoHome}
                              preview={false}
                              width={150}
                              className="mb-4"
                              alt="logo"
                            />
                          </div>
                          <h3 className="form-title m-t0 text-center">
                            Welcome to Wealth Avenue
                          </h3>
                          <div className="dz-separator-outer m-b5">
                            <div className="dz-separator bg-primary style-liner"></div>
                          </div>
                          <p className="sub-title text-center">
                            Access to explore more
                          </p>

                          <div className="login_toggle_container my-4">
                            <button
                              type="button"
                              onClick={() => handleLoginToggle("password")}
                              className={
                                loginToggle === "password"
                                  ? "btn active"
                                  : "btn"
                              }
                            >
                              Password
                            </button>
                            <button
                              type="button"
                              onClick={() => handleLoginToggle("mobilefield")}
                              className={
                                loginToggle === "mobilefield"
                                  ? "btn active"
                                  : "btn"
                              }
                            >
                              OTP
                            </button>
                          </div>
                          <div>
                            {loginToggle === "password" && (
                              <form
                                className=" dz-form pb-3"
                                onSubmit={!isLoading ? onLogin : null}
                              >
                                <div className="form-group mb-3">
                                  <label>Email</label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Please Enter"
                                  />
                                  {errors.email && (
                                    <div className="text-danger fs-12">
                                      {errors.email}
                                    </div>
                                  )}
                                </div>
                                <div className="password-container form-group mb-3">
                                  <label>Password</label>
                                  <input
                                    type="password"
                                    id="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                    placeholder="Please Enter"
                                  />
                                  <i
                                    className="far fa-eye"
                                    id="togglePassword"
                                    onMouseEnter={() => toggleSwitchPassword()}
                                  ></i>
                                  {errors.password && (
                                    <div className="text-danger fs-12">
                                      {errors.password}
                                    </div>
                                  )}
                                </div>
                                <div className="form-group mb-5 d-flex align-items-start justify-content-between">
                                  <span className="form-check d-inline-block ms-2">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="check1"
                                      name="example1"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="check1"
                                    >
                                      Remember me
                                    </label>
                                  </span>
                                  <span>
                                    <NavLink
                                      to="/open/forgetpassword"
                                      className="ms-auto"
                                    >
                                      Forgot Password ?
                                    </NavLink>
                                  </span>
                                </div>
                                <div
                                  className={Object.className({
                                    "form-group text-left": true,
                                    // "not-allowed": isLoading,
                                    "not-allowed": true,
                                  })}
                                >
                                  <button
                                    type="submit"
                                    className="btn btn-primary button-md btn-block"
                                    disabled={isLoading}
                                  >
                                    {isLoading ? "Loading…" : "login"}
                                  </button>
                                </div>
                              </form>
                            )}
                          </div>
                          <div>
                            {loginToggle === "mobilefield" && (
                              <form
                                className=" dz-form pb-3"
                                onSubmit={onEmployeeOtpLogin}
                              >
                                <div className="form-group my-4">
                                  <label htmlFor="">Mobile no.</label>
                                  <div className="position-relative">
                                    <input
                                      type="text"
                                      onChange={(e) =>
                                        setMobilefield(e.target.value)
                                      }
                                      className="form-control"
                                      placeholder="Please Enter"
                                    />
                                    <img
                                      className="user-icon"
                                      src={imagepaths.InputUserIcon}
                                      alt="user icon"
                                    />
                                  </div>
                                  {/* {errors.email && (
                                        <div className="text-danger fs-12">
                                          {errors.email}
                                        </div>
                                      )} */}
                                  {/* {otpErrors.mobilefield && (
                                  <div className="text-danger fs-12">
                                    {otpErrors.mobilefield}
                                  </div>
                                )} */}
                                </div>
                                <div
                                  className={Object.className({
                                    "form-group text-left": true,
                                    // "not-allowed": isMobileLoading,
                                    "not-allowed": true,
                                  })}
                                >
                                  <button
                                    type="submit"
                                    className="btn btn-primary button-md btn-block"
                                    disabled={isMobileLoading}
                                  >
                                    {isMobileLoading ? "Loading…" : "Send OTP"}
                                  </button>
                                </div>
                              </form>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default constore(Login);
